import PartnerMap from './partnerMap'

export default PartnerMap